"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.location = exports.loadLocationList = void 0;
const ComplexSelect_1 = __importDefault(require("@/class/ComplexSelect"));
const select_1 = __importDefault(require("../api/select"));
const load_1 = __importDefault(require("./load"));
const formatList = function (list) {
    return list.map((oitem) => {
        const item = {
            value: oitem.bankNo,
            label: oitem.bankName
        };
        if (oitem.regionList) {
            item.children = formatList(oitem.regionList);
        }
        return item;
    });
};
const loadLocationList = function () {
    return new Promise((resolve, reject) => {
        select_1.default.location.require().then((res) => {
            const locationList = formatList(res.data.data);
            resolve({ status: 'success', data: locationList });
        }).catch(err => {
            // eslint-disable-next-line no-console
            console.error(err);
            reject(err);
        });
    });
};
exports.loadLocationList = loadLocationList;
exports.location = new ComplexSelect_1.default({
    name: '省市区',
    list: [],
    getData() {
        return new Promise((resolve, reject) => {
            load_1.default.pushControl('location', {
                offset: 10 * 1000,
                priority: 1,
                local: 'location',
                check(localData) {
                    if (localData) {
                        return true;
                    }
                },
                load() {
                    return (0, exports.loadLocationList)();
                },
                init(initData) {
                    exports.location.setList(initData);
                }
            }).then(res => {
                resolve({ status: res.status, list: res.data });
            }).catch(reject);
        });
    }
});
